export const sortArrayCaseInsensitive = (items, selector) => items.sort((o1, o2) => {
  const v1 = selector(o1);
  const v2 = selector(o2);
  return v1.toUpperCase().localeCompare(v2.toUpperCase());
});
